import React, { useState } from 'react';
import { Button, Dialog, DialogContent, Grid } from '@mui/material';
import { useSnackbar } from 'notistack';
import { makeStyles } from '@mui/styles';

import { callRestGetEndpoint } from '@/common/utils/api';

const useStyles = makeStyles(() => ({
  dialogPaper: {
    minHeight: '80vh',
    maxHeight: '80vh'
  }
}));

const UploadedDocumentView = ({ closeModal, documentId }) => {
  const { enqueueSnackbar } = useSnackbar();
  const classes = useStyles();
  const [docSrc, setDocSrc] = useState(undefined);
  const [open, setOpen] = useState(true);

  React.useEffect(() => {
    getDocument();
  }, []);

  const getDocument = async () => {
    try {
      const res = await callRestGetEndpoint(
        { document_id: documentId },
        '/pos_customer/customer_upload_document_view/'
      );
      setDocSrc(res.url);
    } catch (e) {
      enqueueSnackbar('A problem was encountered retrieving the document.', {
        variant: 'error'
      });
    }
  };

  return (
    <Dialog
      open={open}
      onClose={() => setOpen(false)}
      maxWidth="md"
      fullWidth={true}
      classes={{ paper: classes.dialogPaper }}
    >
      <DialogContent
        style={{
          padding: 5,
          marginTop: 0,
          display: 'block',
          height: '100%'
        }}
      >
        <iframe
          src={docSrc}
          style={{
            border: 'none',
            height: 'calc(80vh - 74px)',
            width: '100%',
            overflow: 'hidden'
          }}
        />
      </DialogContent>
      <div
        style={{
          width: '100%',
          padding: '10px',
          display: 'flex',
          background: '#fafafa',
          justifyContent: 'flex-end'
        }}
      >
        <Grid container spacing={2} justifyContent="flex-end">
          <Grid item>
            <Button color="primary" variant="contained" onClick={closeModal}>
              Close
            </Button>
          </Grid>
        </Grid>
      </div>
    </Dialog>
  );
};

export default UploadedDocumentView;
